import React from "react";

export default function MSAccess_TimeValue() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MSAccess_TimeValue</h1>
      <p>This is the MSAccess_TimeValue component generated from the SQL JSON.</p>
    </div>
  );
}
